/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Plh_IntroInputs */

const vi_pkl_plh_intro = /** @type {(inputs: Pkl_Plh_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi lại các lô vật tư đã khiêng ra khỏi kho để đưa vào đóng gói. Phiếu không trừ tồn kho.`)
};

/**

* @param {Pkl_Plh_IntroInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_plh_intro = /** @type {((inputs?: Pkl_Plh_IntroInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Plh_IntroInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_plh_intro(inputs)
});